<div class="page">
    <kgrid 
    [apiName]="apiName"
    [noAutoFitColumns]="true"
    [areaName]="areaName"
    [label]="label"
    [name]="apiName"
    [isMulti]="true"
    [isAdd]="isAdd"
    [isEdit]="isEdit"
    [isDelete]="isDelete"
    [inputEditorform]="inputEditorform">
</kgrid>
</div>
